import React, { useMemo } from "react";
import cx from "classnames";
import * as Scrivito from "scrivito";
import { projectTranslations } from "config/locals/projectTranslations";
import { useTranslate } from "hooks";
import { Icon } from "../Icon/Icon";
import type { IconName } from "../Icon/iconNames";
import s from "./FilterTag.module.scss";

type FilterTagProps = {
  name?: string;
  color?: string;
  icon?: IconName;
};

type ProjectTranslationKey = keyof typeof projectTranslations;

export const FilterTag = Scrivito.connect(
  ({ name, color, icon }: FilterTagProps) => {
    const translate = useTranslate();
    const translateProp = useMemo(
      () => (name ? `PROJECT_STATUS_${name}` : ""),
      [name],
    );

    return (
      <div className={s.filterTag}>
        {color && (
          <div
            className={cx("mr-2 rounded-circle icon-12")}
            style={{ background: color }}
          />
        )}
        {icon && <Icon iconName={icon}></Icon>}
        {projectTranslations[
          translateProp.toUpperCase() as ProjectTranslationKey
        ]
          ? translate(translateProp)
          : name}
      </div>
    );
  },
);
